import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

const FIT_OPTIONS = [
  { id: 'snug', icon: ArrowDown },
  { id: 'regular', icon: Minus },
  { id: 'loose', icon: ArrowUp },
];

export default function FitAdvisor({ t, fitPreference, onFitChange, neighborSizes, onPickSize, systemId }) {
  if (!neighborSizes?.smaller && !neighborSizes?.larger) return null;

  const suggestion =
    fitPreference === 'snug' && neighborSizes.smaller
      ? neighborSizes.smaller
      : fitPreference === 'loose' && neighborSizes.larger
        ? neighborSizes.larger
        : null;

  const suggestValue = suggestion?.[systemId];

  return (
    <div className="rounded-xl border border-slate-700 bg-slate-900/60 p-4 mt-4">
      <p className="text-sm font-medium text-slate-200 mb-3">{t.fitAdvisor.title}</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {FIT_OPTIONS.map(({ id, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onFitChange(id)}
            className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm border transition-colors ${
              fitPreference === id
                ? 'bg-emerald-600 border-emerald-500 text-white'
                : 'border-slate-600 text-slate-300 hover:border-emerald-600/50'
            }`}
          >
            <Icon className="w-4 h-4" />
            {t.fitAdvisor[id]}
          </button>
        ))}
      </div>
      {suggestValue && fitPreference !== 'regular' && (
        <button
          type="button"
          onClick={() => onPickSize(suggestValue)}
          className="text-sm text-emerald-400 hover:text-emerald-300 underline-offset-2 hover:underline"
        >
          {t.fitAdvisor.trySize}: <strong>{suggestValue}</strong>
        </button>
      )}
      {fitPreference === 'regular' && (
        <p className="text-xs text-slate-500">{t.fitAdvisor.regularHint}</p>
      )}
    </div>
  );
}
